import React, { useState } from 'react';
import { FormCheckbox } from 'shards-react';
import type { OrganizationUserType } from '../../types/user';
import getOrganizationDisplayNameByOrganizationUser from '../../utils/getOrganizationDisplayNameByOrganizationUser';
import { RootState, useSelector } from '../../redux/store';
import useLocales from '../../hooks/useLocales';

interface SelectNotificationProps {
  disabled: boolean;
  organizationUser: OrganizationUserType;
  onChange?: (organizationUser: OrganizationUserType) => void;
}

/**
 * メール通知を制御するコンポーネント。OrganizationUserTypeを引数に取るコールバックがあれば実行する。
 * @param disabled [boolean]
 * @param organizationUser [OrganizationUserType]
 * @param onChange? (OrganizationUserType) => void;
 * @returns React.ReactElement
 */
const SelectNotification = ({ disabled, organizationUser, onChange = () => {} }: SelectNotificationProps): React.ReactElement => {
  const { currentLang } = useLocales();
  const { organizations } = useSelector((state: RootState) => state.organization);
  const { organizationBase, tradingCompany } = useSelector((state: RootState) => state.options);
  const displayName: string = getOrganizationDisplayNameByOrganizationUser(organizationUser, organizations, {
    organizationBases: organizationBase,
    tradingCompanies: tradingCompany,
    language: currentLang.value,
  });
  const [selectedOrganizationUser, setSelectedOrganizationUser] = useState<OrganizationUserType>(organizationUser);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // チェックボックスをクリックしたとき
  const handleToggle = () => {
    const newOrganizationUser: OrganizationUserType = Object.assign({}, selectedOrganizationUser, {
      emailNotificationFlag: !selectedOrganizationUser.emailNotificationFlag,
    });
    // console.log(newOrganizationUser);
    setSelectedOrganizationUser(newOrganizationUser);
    onChange(newOrganizationUser);
  };

  // VIEW
  // ================================================================================

  return (
    <FormCheckbox disabled={disabled} checked={selectedOrganizationUser.emailNotificationFlag} onChange={handleToggle}>
      {displayName}
    </FormCheckbox>
  );
};

export default SelectNotification;
